import { resolveForumScope } from './forumPermissions';

/** Build display list for forum info panel — shows effective (narrowest) scope only. */
export function getForumParticipantDisplayList(forum) {
  if (!forum) return [];

  const scope = resolveForumScope(forum);
  const entries = [];

  if (scope === 'individual') {
    (forum.ForumMembers || [])
      .filter((member) => member.role === 'participant')
      .forEach((member) => {
        const name = member.CorporateUser?.full_name?.trim();
        if (name) entries.push({ id: `user-${member.user_id}`, name, type: 'user' });
      });
    return entries;
  }

  if (scope === 'sub_department') {
    (forum.ForumSubDepartments || [])
      .filter((item) => item.is_participant !== false)
      .forEach((item) => {
        const name = item.SubDepartment?.name?.trim();
        if (name) entries.push({ id: `subdept-${item.sub_department_id}`, name, type: 'org' });
      });
    return entries;
  }

  if (scope === 'department') {
    (forum.ForumDepartments || [])
      .filter((item) => item.is_participant !== false)
      .forEach((item) => {
        const name = item.Department?.name?.trim();
        if (name) entries.push({ id: `dept-${item.department_id}`, name, type: 'org' });
      });
    return entries;
  }

  if (scope === 'branch') {
    (forum.ForumBranches || [])
      .filter((item) => item.is_participant !== false)
      .forEach((item) => {
        const name = item.Branch?.name?.trim();
        if (name) entries.push({ id: `branch-${item.branch_id}`, name, type: 'org' });
      });
  }

  return entries;
}

function addAssignableUser(byId, user) {
  const id = Number(user?.id);
  const name = user?.full_name?.trim();
  if (!id || !name || byId.has(id)) return;
  byId.set(id, { id, full_name: name });
}

/** People assigned to the forum (creator + individual participants). */
export function getForumAssignedIndividuals(forum) {
  const byId = new Map();
  addAssignableUser(byId, forum?.creator);
  (forum?.ForumMembers || []).forEach((member) => {
    addAssignableUser(byId, member.CorporateUser || { id: member.user_id, full_name: member.CorporateUser?.full_name });
  });
  return Array.from(byId.values());
}

function participantOrgIds(rows, idKey, nestedKey) {
  return (rows || [])
    .filter((item) => item.is_participant !== false)
    .map((item) => item[idKey] || item[nestedKey]?.id)
    .filter(Boolean);
}

/**
 * Org filters for the forum's effective assignment scope.
 * Null when assignment is individual (or none) — use getForumAssignedIndividuals instead.
 */
export function getForumAssignedOrgQuery(forum) {
  const scope = resolveForumScope(forum);
  if (scope === 'sub_department') {
    const ids = participantOrgIds(forum?.ForumSubDepartments, 'sub_department_id', 'SubDepartment');
    return ids.length ? { sub_department: ids.join(',') } : null;
  }
  if (scope === 'department') {
    const ids = participantOrgIds(forum?.ForumDepartments, 'department_id', 'Department');
    return ids.length ? { department: ids.join(',') } : null;
  }
  if (scope === 'branch') {
    const ids = participantOrgIds(forum?.ForumBranches, 'branch_id', 'Branch');
    return ids.length ? { branch: ids.join(',') } : null;
  }
  return null;
}
